// MapStrip (round 2, a board composition): under the day board, the day's map with every technician's
// route, and beside it a legend of each route: their pen and name, their stops, their driving (BL-158
// 12). The map is a slot: the Map page's map in the app, a drawing from made-up points in Storybook (no
// key, no network). Reads only --mapstrip-*.
import type { ReactNode } from 'react';
import type { Pen } from '../pen.ts';
import { PenKey } from '../PenKey/PenKey.tsx';
import './MapStrip.css';

export interface MapRoute {
  name: string;
  pen?: Pen | null;
  /** "4 stops, 52 min driving". */
  line: string;
  /** What's wrong with it, in red ("A drive doesn’t fit"). */
  bad?: string | null;
}

export interface MapStripProps {
  /** The map itself. */
  map: ReactNode;
  routes: MapRoute[];
  /** For screen readers: "The day’s routes". */
  label?: string;
}

export function MapStrip({ map, routes, label = 'The day’s routes' }: MapStripProps) {
  return (
    <section className="fl-mapstrip" aria-label={label}>
      <div className="fl-mapstrip__in">
        <div className="fl-mapstrip__map">{map}</div>
        <div className="fl-mapstrip__legend">
          <p className="fl-mapstrip__label">Routes</p>
          {routes.length ? (
            <ul className="fl-mapstrip__list">
              {routes.map((r) => (
                <li key={r.name} className="fl-mapstrip__row">
                  <span className="fl-mapstrip__name">
                    <PenKey pen={r.pen}>{r.name}</PenKey>
                  </span>
                  <span className="fl-mapstrip__line">
                    {r.line}
                    {r.bad ? (
                      <>
                        {', '}
                        <span className="fl-mapstrip__bad">{r.bad}</span>
                      </>
                    ) : null}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="fl-mapstrip__empty">Nothing to map yet: no visits have an address today.</p>
          )}
        </div>
      </div>
    </section>
  );
}
